import React, { createContext, type ReactNode, useContext } from 'react';

import { type ExternalData } from '../../../types';

const FALLBACK = {};

const ExternalDataContext = createContext<ExternalData | undefined>(undefined);

export interface ExternalDataProviderProps {
  children: ReactNode;
  externalData?: ExternalData;
}

export const ExternalDataProvider = ({
  children,
  externalData,
}: ExternalDataProviderProps) => {
  return (
    <ExternalDataContext.Provider value={externalData ?? FALLBACK}>
      {children}
    </ExternalDataContext.Provider>
  );
};

export function useExternalData() {
  const context = useContext(ExternalDataContext);
  if (context === undefined) {
    throw new Error(
      'useExternalData must be used within a ExternalDataProvider',
    );
  }
  return context;
}
